// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import {
  SectionQuoteRecommendation,
  type SectionQuoteRecommendationProps,
} from './SectionQuoteRecommendation';

/**
 * Backward-compatible alias for {@link SectionQuoteRecommendation} (the
 * `PENSION_RECOMMENDATION` name predates the Investment & Protection
 * Proposals generalisation — docs/specs/investment-protection-proposals-prd.md
 * RQ-8). Kept so the existing pension-only test suite + any external imports
 * keep working; new call sites should reach for `SectionQuoteRecommendation`
 * directly.
 */
export type SectionPensionRecommendationProps = SectionQuoteRecommendationProps;

export const SectionPensionRecommendation = SectionQuoteRecommendation;

export default SectionPensionRecommendation;
